/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
// BASE components
import BASESvgIcon from '../../../../@BASE/core/BASESvgIcon';
// Material-UI
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';

function TemplateListItemInfo(props) {
	const { template } = props;

	if (!template) {
		return null;
	}

  const formatClassification = (classification) => {
    return classification
      .replace(/_/g, ' ')
      .split(' ')
      .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
      .join(' ');
  }

  return (
    <div className='w-full'>
      <Typography className="text-15 font-medium">{template.title}</Typography>
      <div className="flex items-center space-x-16 mt-12">
        <Typography
          className="flex items-center space-x-6 text-md"
          color="text.secondary"
        >
          <BASESvgIcon
            color="disabled"
            size={20}
          >
            heroicons-outline:color-swatch
          </BASESvgIcon>
          <span className="whitespace-nowrap leading-none">{formatClassification(template.classification)}</span>
        </Typography>
        <Typography
          className="flex items-center space-x-6 text-md"
          color="text.secondary"
        >
          <BASESvgIcon
            color="disabled"
            size={20}
          >
            heroicons-outline:tag
          </BASESvgIcon>
          <span className="whitespace-nowrap leading-none">{template.label}</span>
        </Typography>
      </div>
      <Divider
        className="w-48 my-24 border-1"
      />
      <Typography
        className="text-md mt-2 line-clamp-2"
        color="text.secondary"
      >
        {template.description}
      </Typography>
    </div>
  );
}

export default TemplateListItemInfo;
